import { scrollToId } from "./Reveal";

export default function Nav() {
  return (
    <header
      data-testid="nav-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-[#FFFFFF]/80 border-b border-[#0B0B12]/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo-hercules"
          onClick={() => scrollToId("hero")}
          className="flex items-center gap-2.5"
          aria-label="HERcules Health — back to top"
        >
          <img src="/images/logo.png" alt="HERcules Health logo" className="h-11 w-auto" />
          <span className="sr-only">HERcules Health</span>
        </button>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#4A4A66]">
          <button data-testid="nav-link-reset" onClick={() => scrollToId("manifesto")} className="hover:text-[#0B0B12] transition-colors">The Reset</button>
          <button data-testid="nav-link-how-it-works" onClick={() => scrollToId("how-it-works")} className="hover:text-[#0B0B12] transition-colors">How It Works</button>
          <button data-testid="nav-link-about" onClick={() => scrollToId("about")} className="hover:text-[#0B0B12] transition-colors">Who Am I?</button>
        </nav>
        <button
          data-testid="nav-join-reset-button"
          onClick={() => scrollToId("register")}
          className="rounded-full bg-[#0B0B12] text-[#FFFFFF] px-4 sm:px-5 py-2 text-xs sm:text-sm font-semibold hover:bg-[#1B2FD8] transition-colors duration-300"
        >
          <span className="sm:hidden">JOIN FREE</span>
          <span className="hidden sm:inline">JOIN THE RESET</span>
        </button>
      </div>
    </header>
  );
}
